// extracted by mini-css-extract-plugin
export default {"root":"_1ZZGj_Wr-bcHBUMWIIdaoZ","outlineBtn":"_3uVmx69jTLLqNoUiC3FCam"};